import React, { useContext } from 'react'
import { APIState } from '../State/APIClient'

import { ListGroup, ListGroupItem, Badge, Col, Row } from 'reactstrap'
import { NeedData } from '../Prerequisites/NeedData'

export const Monitor: React.FC = () => {
    let api = useContext(APIState)

    if (!api.serverState)
        return <NeedData />

    let serverState = api.serverState

    let teams = serverState.teams.filter(team => !team.isLobby)
    teams.sort((a, b) => b.score - a.score)

    let maxScore = teams.map(team => team.score).find(_ => true)

    let titleText = serverState.buzzersEnabled ? 'Please Buzz!!' : 'Scoreboard'
    if (serverState.cooldown !== undefined)
        titleText += ' (' + serverState.cooldown + ')'

    return <>
        <Row>
            <Col md={{size:8, offset: 2}}>
                <h1 style={{ color: 'white', fontSize: '4.5em' }}>
                    {titleText}
                </h1>
            </Col>
        </Row>

        <Row>
            <Col md={{size:8, offset: 2}} style={{fontSize: '2.5em'}}>
                {teams.map(team => {
                    return <ListGroup key={team.uuid}>
                        <ListGroupItem style={{
                            textAlign: 'left',
                            backgroundColor: team.score === maxScore ? '#df691a' : 'grey',
                            color: 'white',
                            userSelect: 'none',
                            display: 'flex',
                            justifyContent: 'space-between',
                            whiteSpace: 'nowrap'
                        }} key={team.uuid} >
                            <span style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}>{team.name}</span> {' '}
                            <span style={{fontSize: '0.9em'}}>
                                {serverState.lastWinner === team.uuid ? <Badge color="primary" style={{marginRight: '0.8em'}}>BUZZED</Badge> : null}
                                <span style={{ textAlign: 'right', paddingRight: '1em' }}>
                                    {team.score}
                                    {team.score === 1 ? ' point' : ' points'}
                                </span>
                            </span>
                        </ListGroupItem>
                    </ListGroup>
                })}
            </Col>
        </Row>
    </>
}